export default {
  // 获取发出邀请用户的信息
  getInviterInfo: '/amc/client/getInviterInfo',
}